import { render, staticRenderFns } from "./ScriptEdit.vue?vue&type=template&id=4db8b299&scoped=true"
import script from "./ScriptEdit.vue?vue&type=script&lang=js"
export * from "./ScriptEdit.vue?vue&type=script&lang=js"
import style0 from "./ScriptEdit.vue?vue&type=style&index=0&id=4db8b299&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db8b299",
  null
  
)

export default component.exports